// src/components/ui/feedback/StatusBadge/StatusBadge.jsx
import React from 'react';
import { 
  CheckCircle2, 
  XCircle, 
  AlertCircle, 
  Clock,
  Calendar,
  User
} from 'lucide-react';
import { cn } from '../../../../utils/cn';

const StatusBadge = ({
  status,
  size = 'md', // sm, md, lg
  showIcon = true,
  className = ''
}) => {
  // Status configurations with colors and icons
  const statusConfigs = {
    confirmed: {
      color: "text-emerald-400",
      bg: "bg-emerald-500/10",
      border: "border-emerald-500/30",
      icon: CheckCircle2,
      label: "Confirmed"
    },
    pending: {
      color: "text-amber-400",
      bg: "bg-amber-500/10",
      border: "border-amber-500/30",
      icon: Clock,
      label: "Pending"
    },
    in_progress: {
      color: "text-blue-400",
      bg: "bg-blue-500/10",
      border: "border-blue-500/30",
      icon: AlertCircle,
      label: "In Progress"
    },
    completed: {
      color: "text-emerald-400",
      bg: "bg-emerald-500/10",
      border: "border-emerald-500/30",
      icon: CheckCircle2,
      label: "Completed"
    },
    cancelled: {
      color: "text-red-400",
      bg: "bg-red-500/10",
      border: "border-red-500/30",
      icon: XCircle,
      label: "Cancelled"
    }
  };

  // Size configurations
  const sizeConfigs = {
    sm: {
      container: "px-2 py-1 text-xs gap-1",
      icon: "w-3 h-3"
    },
    md: {
      container: "px-2 py-1 text-xs gap-1.5",
      icon: "w-3 h-3"
    },
    lg: {
      container: "px-3 py-1.5 text-sm gap-2",
      icon: "w-4 h-4"
    }
  };

  const statusConfig = statusConfigs[status] || statusConfigs.pending;
  const sizeConfig = sizeConfigs[size];
  const StatusIcon = statusConfig.icon;

  return (
    <div className={cn(
      // Base styles
      "inline-flex items-center rounded-lg border font-medium",
      
      // Status colors
      statusConfig.bg,
      statusConfig.border,
      statusConfig.color,
      
      // Size styles
      sizeConfig.container,
      
      className
    )}>
      {/* Status Icon */}
      {showIcon && (
        <StatusIcon className={sizeConfig.icon} />
      )}
      
      {/* Status Label */}
      <span>{statusConfig.label}</span>
    </div>
  );
};

export default StatusBadge;